<div #overlay class="overlay">
    <div class="content center-content">
        <div class="column-flex">
            <div class="approve-title" data-cy="vessel-folder-req-approval-approver-approve-confirmation-modal-header">
                {{ 'approve.publish.dialog.title' | translate: { version: data.version } }}
            </div>
            <div class="approve-message" data-cy="vessel-folder-req-approval-approver-approve-confirmation-modal-body">
                {{ 'approve.publish.dialog.message' | translate: { userName: data.userName } }}
            </div>
            <div class="buttons-container">
                <div
                    class="cancel button"
                    data-cy="vessel-folder-req-approval-approver-approve-confirmation-modal-cancel-btn"
                    (click)="cancel()">
                    {{ 'approve.publish.dialog.button.cancel' | translate }}
                </div>
                <div
                    class="create button"
                    data-cy="vessel-folder-req-approval-approver-approve-confirmation-modal-submit-btn"
                    (click)="acceptPublish()">
                    {{ 'approve.publish.dialog.button.confirm' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
